import { AgentApprovalOutcomeReason } from '../../types/agentHarness';

/**
 * What a settled approval card says about the write.
 *
 * Every card that closed without a yes used to read "Rejected — nothing ran",
 * so an approval that expired, or died with its turn, told the person they had
 * turned it down. Only `denied` is their choice; the rest say why it did not
 * run without blaming anyone.
 */
const NOT_RUN_LABELS: Record<AgentApprovalOutcomeReason, string> = {
	denied: 'Rejected — nothing ran.',
	timeout: 'Not answered in time — not run',
	ended: 'Chat stopped before approval — not run',
	drain: 'Service updating — not run',
	cancelled: 'Stopped — not run',
	refused: 'Could not be recorded — not run',
	missing: 'No longer pending',
};

/** An older harness sends no reason, so it cannot say whose choice it was. */
const UNKNOWN_NOT_RUN = 'Not run';

export const approvalOutcomeLabel = (
	approved: boolean,
	reason?: AgentApprovalOutcomeReason
): string => {
	if (approved) {
		return 'Approved — the agent ran it.';
	}
	return (reason && NOT_RUN_LABELS[reason]) || UNKNOWN_NOT_RUN;
};

/** The same, shortened for one row of a batch card. */
export const approvalRowOutcomeLabel = (
	approved: boolean,
	reason?: AgentApprovalOutcomeReason
): string => {
	if (approved) {
		return 'Approved';
	}
	if (reason === 'denied') {
		return 'Rejected';
	}
	return (reason && NOT_RUN_LABELS[reason]) || UNKNOWN_NOT_RUN;
};
